import CustomTextArea from "@/components/CustomTextArea";
import Text from "@/components/Text";
import DeleteModal from "@/components/app/DeleteModal";
import { Box } from "@mui/material";
import {
  APPOINTMENT_CHANGE_STATUS,
  APPOINTMENT_STATUS_CHANGE_LABEL,
  APPOINTMENT_STATUS_CHANGE_MESSAGE,
  APPOINTMENT_STATUS_CHANGE_MODAL_WIDTH,
  APPOINTMENT_STATUS_CHANGE_REASON_MIN_ROWS,
  APPOINTMENT_STATUS_CHANGE_REASON_PLACEHOLDER,
} from "./appointment-status-change-constant";
import { AppointmentStatusChangeModalProps } from "./appointment-status-change-types";
import { useAppointmentStatusChange } from "./hooks/use-appointment-status-change";

/**
 * @author [Rajkumar Rathod]
 */
const AppointmentStatusChangeModal = (
  props: AppointmentStatusChangeModalProps
) => {
  const { disclosureHost, status } = props;
  const { reason, setReason, handleClose, handleConfirm } =
    useAppointmentStatusChange(props);

  if (!disclosureHost.opened) return null;

  const isCancelled = status === APPOINTMENT_CHANGE_STATUS.CANCELLED;

  return (
    <DeleteModal
      disableOnSaveSnackbar
      w={APPOINTMENT_STATUS_CHANGE_MODAL_WIDTH}
      open={disclosureHost.opened}
      onClose={handleClose}
      onConfirmation={handleConfirm}
      content={
        isCancelled ? (
          <Box>
            <Text align="center">
              {APPOINTMENT_STATUS_CHANGE_MESSAGE.CANCEL_INTENT}
            </Text>
            <Text align="center">
              {APPOINTMENT_STATUS_CHANGE_MESSAGE.CANCEL_CONFIRM}
            </Text>
          </Box>
        ) : (
          APPOINTMENT_STATUS_CHANGE_MESSAGE.NO_SHOW_CONFIRM
        )
      }
      input={
        <Box width={"100%"}>
          <CustomTextArea
            required
            label={APPOINTMENT_STATUS_CHANGE_LABEL.REASON}
            value={reason}
            minRows={APPOINTMENT_STATUS_CHANGE_REASON_MIN_ROWS}
            placeholder={
              isCancelled
                ? APPOINTMENT_STATUS_CHANGE_REASON_PLACEHOLDER.CANCELLED
                : APPOINTMENT_STATUS_CHANGE_REASON_PLACEHOLDER.NO_SHOW
            }
            onChange={(e) => setReason(e.currentTarget.value)}
          />
        </Box>
      }
      confirmButtonText={APPOINTMENT_STATUS_CHANGE_LABEL.CONFIRM}
      cancelButtonText={APPOINTMENT_STATUS_CHANGE_LABEL.CANCEL}
    />
  );
};

export default AppointmentStatusChangeModal;
